<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card>
          <v-card-title
            class="d-flex align-center"
            style="background-color: #2196f3 !important; color: #ffffff"
          >
            <span>{{ action }} OJT Submission</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    @change="setLabelSelected"
                    density="compact"
                    label="Select type of file to submit"
                    v-model="selected_type"
                    item-value="id"
                    item-title="name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    chips
                    :readonly="action != 'Add'"
                    :items="typeList"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  v-if="getTypeOfFileSelected.toLocaleLowerCase() == 'dtr'"
                >
                  <div style="border: 1px solid gray" class="rounded-md pa-2">
                    <div class="text-caption">
                      Please click the link to
                      <button
                        style="text-decoration: underline"
                        class="text-blue"
                      >
                        <download-csv :data="json_data" name="dtr_format.csv">
                          Download DTR .csv file format
                        </download-csv>
                      </button>
                      for uploading DTR. Click the link to
                      <a
                        href="/excel/SAMPLE-IPCR-Jan-Jun-2025.xlsx"
                        download="SAMPLE-IPCR-Jan-Jun-2025.xlsx"
                        class="text-blue"
                      >
                        Download DTR Generator
                      </a>
                    </div>
                  </div>
                </v-col>
                <v-col v-if="action != 'View'">
                  <v-file-input
                    v-model="file"
                    :rules="[formRules.required, formRules.isPDFFile]"
                    variant="outlined"
                    density="compact"
                    accept="application/pdf"
                    :label="label"
                  ></v-file-input>
                </v-col>

                <v-col v-if="remarks" cols="12">
                  <v-textarea
                    v-model="remarks"
                    readonly
                    variant="outlined"
                    density="compact"
                    rows="5"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-btn
              color="green"
              density="comfortable"
              variant="flat"
              v-if="requirement_submission_id"
              @click="viewFile(filename)"
            >
              <v-icon>mdi-text-box-search-outline</v-icon>
              view file
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="closeD()"
              v-if="action != 'View'"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              v-if="action != 'View'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
// import excelFile from "../../../assets/excel/SAMPLE-IPCR-Jan-Jun-2025.xlsx";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      typeList: [],
      selected_type: null,
      showDatePicker: false,
      name: null,
      requirement_id: null,
      requirement_submission_id: null,
      file: null,
      label: null,
      filename: null,
      remarks: null,
      btnLoading: false,
      deletedFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      json_data: [],
      isDownloading: false,
      message: "",
      messageType: "",
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        console.log("Data", data);
        this.generateCSV();
        this.$refs.StudentReqForm.resetValidation();
        this.$refs.StudentReqForm.reset();
        this.name = data.requirement_name;
        this.file = null;
        this.remarks = data.remarks;
        this.selected_type = data.student_requirement_id;
        this.requirement_submission_id = data.requirement_submission_id;
        this.requirement_id = data.requirement_id;
        this.filename = data.file;
      },
      deep: true,
    },
  },
  computed: {
    getTypeOfFileSelected() {
      let file = "";
      if (this.selected_type) {
        for (let i = 0; i < this.typeList.length; i++) {
          if (this.typeList[i].id == this.selected_type) {
            file = this.typeList[i].name;
          }
        }
      }
      return file;
    },
  },
  methods: {
    generateCSV() {
      for (let i = 1; i <= 31; i++) {
        this.json_data.push({
          day: i,
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
          ot_in: null,
          ot_out: null,
          daily_total: null,
        });
      }
    },

    initialize() {
      this.getPrograms();
      this.getTypeOfFiles();
    },

    setLabelSelected() {
      let file = "";
      if (this.selected_type) {
        for (let i = 0; i < this.typeList.length; i++) {
          if (this.typeList[i].id == this.selected_type) {
            file = this.typeList[i].name;
          }
        }
      }

      this.label = "Upload your " + file + " .csv file here.";
      console.log("called", this.label);
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    // async downloadFile() {
    //   this.isDownloading = true;
    //   this.message = "";

    //   try {
    //     // Fetch the imported file
    //     const response = await fetch(excelFile);

    //     if (!response.ok) {
    //       throw new Error("Failed to fetch file");
    //     }

    //     const blob = await response.blob();

    //     // Create download link
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.download = "SAMPLE-IPCR-Jan-Jun-2025.xlsx";
    //     document.body.appendChild(link);
    //     link.click();

    //     // Cleanup
    //     document.body.removeChild(link);
    //     window.URL.revokeObjectURL(url);

    //     this.message = "File downloaded successfully!";
    //     this.messageType = "success";
    //   } catch (error) {
    //     this.message = `Download failed: ${error.message}`;
    //     this.messageType = "error";
    //     console.error("Download error:", error);
    //   } finally {
    //     this.isDownloading = false;
    //   }
    // },

    async testFileExists() {
      const possiblePaths = [
        "./excel/SAMPLE-IPCR-Jan-Jun-2025.xlsx",
        "/excel/SAMPLE-IPCR-Jan-Jun-2025.xlsx",
        // `${process.env.BASE_URL}excel/SAMPLE-IPCR-Jan-Jun-2025.xlsx`,
      ];

      this.message = "Testing file access...";
      this.messageType = "info";

      for (const path of possiblePaths) {
        try {
          const response = await fetch(path, { method: "HEAD" });
          if (response.ok) {
            this.message = `✅ File accessible at: ${path}`;
            this.messageType = "success";
            console.log(`File found: ${path}`);
            return;
          }
        } catch (error) {
          console.log(`Path ${path} failed:`, error.message);
        }
      }

      this.message =
        "❌ File not accessible. Make sure it's in public/assets/excel/ folder";
      this.messageType = "error";
    },

    async save() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          requirement_id: this.selected_type,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.file);
        this.axiosCall(
          "/student-requirement-submission/submitRequirement",
          "POST",
          fd,
        ).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          requirement_submission_id: this.data.id,
          prevFile: this.filename,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.file);
        this.axiosCall(
          "/student-requirement-submission/updateSubmission",
          "PATCH",
          fd,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    closeD() {
      eventBus.emit("closeStudentSubmissionDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    getTypeOfFiles() {
      this.axiosCall("/student/my/getTypeOfFiles", "GET").then((res) => {
        let data = res.data;
        let type = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].name.toLowerCase() != "dtr") {
            type.push(data[i]);
          }
        }
        this.typeList = type;
      });
    },

    viewFile(file) {
      console.log(file);
      let url =
        process.env.VUE_APP_SERVER +
        "/student-requirement-submission/get-file/" +
        file;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          // window.open(_url, "_blank").focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // window.open(url);
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
